// 🔒 Privé-taken: persoonlijke taken die je niet op het gedeelde dagstart-scherm
// van een collega wilt zien. Per gebruiker een lijstje taak-ids in de engine;
// de dagstart verbergt gemarkeerde taken voor iedereen behalve de eigenaar.
// Weergave-privacy, geen security-grens.
import { useEffect, useState } from 'react';
import { AI_ENGINE_URL } from './apiConfig';
import { authFetch } from './authHelpers';

let perEigenaar = null;   // { email: Set(taakIds) }
let belofte = null;

export function laadPriveTaken(vernieuw = false) {
  if (vernieuw) { perEigenaar = null; belofte = null; }
  if (perEigenaar) return Promise.resolve(perEigenaar);
  if (!belofte) {
    belofte = authFetch(`${AI_ENGINE_URL}/api/v1/taken/prive`)
      .then((r) => (r.ok ? r.json() : { per_eigenaar: {} }))
      .then((d) => {
        perEigenaar = {};
        Object.entries(d.per_eigenaar || {}).forEach(([email, ids]) => {
          perEigenaar[email.toLowerCase()] = new Set(ids);
        });
        return perEigenaar;
      })
      .catch(() => { perEigenaar = {}; return perEigenaar; });
  }
  return belofte;
}

/** Moet deze taak verborgen worden voor deze kijker? */
export function isVerborgenVoor(taakId, kijkerEmail) {
  if (!perEigenaar) return false;
  const kijker = String(kijkerEmail || '').toLowerCase();
  return Object.entries(perEigenaar).some(([eigenaar, ids]) => ids.has(String(taakId)) && eigenaar !== kijker);
}

/** Is deze taak door de kijker zelf als privé gemarkeerd? */
export function isEigenPrive(taakId, kijkerEmail) {
  const set = perEigenaar?.[String(kijkerEmail || '').toLowerCase()];
  return Boolean(set && set.has(String(taakId)));
}

export async function zetPrive(taakId, prive, kijkerEmail) {
  const email = String(kijkerEmail || '').toLowerCase();
  const r = await authFetch(`${AI_ENGINE_URL}/api/v1/taken/prive?user_email=${encodeURIComponent(email)}`, {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ task_id: String(taakId), prive }),
  });
  if (!r.ok) throw new Error('Privé-markering opslaan mislukt');
  if (!perEigenaar) perEigenaar = {};
  if (!perEigenaar[email]) perEigenaar[email] = new Set();
  if (prive) perEigenaar[email].add(String(taakId));
  else perEigenaar[email].delete(String(taakId));
}

export function usePriveTaken() {
  const [, setKlaar] = useState(Boolean(perEigenaar));
  useEffect(() => { laadPriveTaken().then(() => setKlaar(true)); }, []);
}
